class Device {
  deviceId: number;
  deviceName: string;
  platform: string;
  lastLogin: string;
  registrationDate: string;

  constructor(deviceId: number, platform: string, deviceName: string, lastLogin: string, registrationDate: string) {
    this.deviceId = deviceId;
    this.deviceName = deviceName;
    this.platform = platform;
    this.lastLogin = lastLogin;
    this.registrationDate = registrationDate;
  }
}

export { Device };
